<template>
    <div id="home" class="wrapper">
        <div class="section-header">
            <div class="div-block-4"></div>
            <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
                <NetworkStatus/>
            <HeaderMenu/>
            </div>
            <div class="top-padding top">
                <div class="header-container left w-container" style="width:auto">

                    <div class="hero-content">
                        <p class="small-top-header">{{$t('local_ads')}} {{$t('powered_by_ai')}}</p>
                        <div class="rich-text-home center _46 left">
                            <p class="top-header">{{$t('local_ads')}}</p>
                            <p class="top-header" style="margin-top:-20px">{{$t('powered_by_ai')}}</p>
                            <p class="sub-header">
                                <b>{{$t('scale_your_business')}}</b>
                                {{$t('with_ads_targeting')}}
                                <b>{{$t('local_customers')}}</b>
                                {{$t('in')}}
                                <b style="color: #17479b"> {{$t('the_cities_and_zip_codes')}}</b>
                            </p>
                        </div>
                        <div class="left-button">
                            <a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a>
                        </div>
                    </div>

                    <div class="rider">
                        <div class="moon"></div>
                        <div class="rocks"></div>
                        <div data-w-id="0f42a724-f40d-fd87-68c7-50c811594470" class="localscale-dude"></div>
                        <div class="zoom">
                            <div data-w-id="1d18d149-2804-e9ff-813a-975d5e339821" style="-webkit-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0" class="zoom-line-4"></div>
                            <div data-w-id="a906bb34-3d8a-415f-083e-09eaca87f5cd" style="-webkit-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0" class="zoom-line-3"></div>
                            <div data-w-id="afe2a1d5-8f14-3089-e012-0ad8732be11e" style="-webkit-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0" class="zoom-line-2"></div>
                            <div data-w-id="0a983149-e38b-f73e-53f6-8dfa01d799e8" style="-webkit-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(300PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0" class="zoom-line-1"></div>
                        </div>
                    </div>
                </div>

                <div class="w-container trusted-container">
                    <div class="rich-text-home center">
                        <p style="font-size: 20px">{{$t('trusted_by_thousands')}}</p>
                    </div>
                </div>
            </div>

            <div class="section section-color center">
                <div class="w-container" style="margin-top: 20px; margin-bottom: 10px">
                    <div class="center-container" style="max-width: 875px">
                        <p class="white opacity-light">Our platform is powered by advanced machine learning algorithms and has delivered billions of ads and millions of leads. We believe businesses of all sizes should be able to harness AI-powered advertising technology, with precise targeting to more than 19k local cities and 41k zip codes.</p>
                    </div>
                    <div class="all-columns">
                        <div class="column">
                            <div class="key-number" style="padding: 0">{{localCities}}+</div>
                            <div class="desc">{{$t('local_cities')}}</div>
                        </div>
                        <div class="column">
                            <div class="key-number" style="padding: 0">{{zipCodes}}+</div>
                            <div class="desc">{{$t('zip_codes')}}</div>
                        </div>
                        <div class="column">
                            <div class="key-number" style="padding: 0">{{adsServedToDate}}+</div>
                            <div class="desc">{{$t('ads_served_to_date')}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="scaleup" class="section section-dark">
                <div class="w-container" style="padding:50px 0 0 0">
                    <div class="center-container">
                        <h3 class="white">Scale your business by targeting local customers where they spend time.</h3>
                        <p class="white opacity-light">Promote your business across thousands of apps and websites. Your ad will target people located in the specific cities and zip codes you choose.</p>
                    </div>

                    <div class="integrations">
                        <div class="w-row">
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/ESPN.png" alt="ESPN" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Investing.com" alt="Investing" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Weather Channel.png" alt="Weather Channel" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Wordscapes.jpg" alt="Wordscapes" class="padding"></span></div>
                        </div>
                        <div class="w-row">
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Zillow.png" alt="Zillow" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/The New York Times.png" alt="The New York Times" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/NHL logo.jpg" alt="NHL" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Yahoo.png" alt="Yahoo" class="padding"></span></div>
                        </div>
                        <div class="w-row">
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Woodoku.jpg" alt="Woodoku" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/FOX Sports.png" alt="FOX Sports" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/WebMD.png" alt="WebMD" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Tumblr.png" alt="Tumblr" class="padding"></span></div>
                        </div>
                        <div class="w-row">
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/NBA.png" alt="NBA" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Sudoku.com.png" alt="Sudoku" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/Twitter X.png" alt="X" class="padding"></span></div>
                            <div class="column w-col w-col-3"><span class="integration-item w-inline-block"><img src="images/publishers/CBS Sports.png" alt="CBS Sports" class="padding"></span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section center" style="padding-bottom: 0">
                <div>
                    <h3>{{$t('plans_and_pricing')}}</h3>
                </div>
                <Plans :what_are_you_waiting_for="false"/>
            </div>

            <div class="section center section-light" style="padding-bottom: 60px">
                <div class="bottom-spacer-20">
                    <h3>{{$t('industry_acknowledged_performance')}}</h3>
                </div>
                <div class="inline">
                    <img src="images/AF-14-PNG-4.png" class="award right-spacer-40" alt="AppsFlyer Performance Index 14"/>
                    <img src="images/Sift-Fast50-Cropped.png" class="award right-spacer-40" alt="Sift Fast 50"/>
                    <img src="images/deloitte-2021-cropped.png" class="award right-spacer-40" alt="Deloitte 2021"/>
                    <img src="images/Inc-5000.png" class="award" alt="Inc 5000"/>
                </div>
            </div>

            <div id="socialproof" class="section socialproof-section">
                <div class="w-container" style="padding:50px 0 0 0">
                    <div class="columns-2 w-row">
                        <div class="column w-col w-col-4">
                            <div class="customers-love-title">
                                <h3 class="inline">{{$t('social_proof')}}</h3>
                                <p class="text-small">{{$t('you_dont_have_to_take_our_word')}}</p>
                            </div>
                        </div>
                        <div class="column w-col w-col-8">
                            <div data-animation="outin" data-easing="ease-in-out" data-nav-spacing="10" data-duration="300" data-infinite="1" class="slider testimonials-slider w-slider">
                                <div class="slider-mask w-slider-mask">
                                    <div class="testimonials-slide w-clearfix w-slide">
                                        <div class="slide-avatar avatar-2"></div>
                                        <div class="slide-content light">
                                            <p class="text-medium">&quot;{{$t('charles_douthitt_testimonial')}}&quot;</p>
                                            <div class="w-row">
                                                <div class="w-col w-col-10">
                                                    <div class="testimonial-subtitle testimonial-name"><strong>Charles Douthitt</strong></div>
                                                    <p class="text-small">{{$t('charles_douthitt_title')}}</p>
                                                </div>
                                                <div class="column-4 w-col w-col-2"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="slider-arrow-back w-slider-arrow-left">
                                    <div class="slider-arrow-icon w-icon-slider-left"></div>
                                </div>
                                <div class="slider-arrow-next w-slider-arrow-right">
                                    <div class="slider-arrow-icon w-icon-slider-right"></div>
                                </div>
                                <div class="slider-nav w-slider-nav w-slider-nav-invert w-round"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section yellow">
                <div class="w-container" style="padding:50px 0 0 0">
                    <div class="center-container neg-128">
                        <img src="images/100-Go.svg" alt="Racecar" class="racecar">
                        <h3 class="center margin-top"><strong class="bold-text">{{$t('what_are_you_waiting_for')}}</strong></h3>
                        <p class="center on-yellow">{{$t('we_are_confident')}}</p>
                    </div>
                    <div class="threeacross">
                        <div class="_123">
                            <div class="circle">
                                <div class="text-block">1</div>
                            </div>
                            <h6 class="heading-2">{{$t('set_a_budget')}}</h6>
                            <p class="text-small on-yellow">{{$t('plans_starting_at')}}</p>
                        </div>
                        <div class="_123">
                            <div class="circle">
                                <div class="text-block">2</div>
                            </div>
                            <h6 class="heading-2">{{$t('create_an_ad')}}</h6>
                            <p class="text-small">{{$t('upload_your_own_images')}}</p>
                        </div>
                        <div class="_123">
                            <div class="circle">
                                <div class="text-block">3</div>
                            </div>
                            <h6 class="heading-2">{{$t('set_your_targeting')}}</h6>
                            <p class="text-small">{{$t('target_cities_and_zip_codes')}}</p>
                        </div>
                    </div>
                    <div class="button-container center top-spacer-40">
                        <a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        <img src="https://vapinteg.prod.sift.co/conversion?pid=816&cid=15557" alt="Conversion Tracker" width="0" height="0" style="display:none"/>
    </div>
</template>

<style>
    .small-top-header {
        display: none;
    }
    .top-header {
        font-size: 56px;
        font-weight: bold;
        color: #000;
    }
    .award {
        max-height: 150px;
        padding: 10px;
    }
    .sub-header {
        font-size: 24px;
        color: #000;
        font-weight: normal;
    }
    h3 {
        margin-top: 0;
        margin-bottom: 10px;
        font-size: 30px;
        line-height: 1.4;
        font-weight: 700;
        letter-spacing: -0.5px;
        text-indent: -1px;
    }
    h6 {
        margin-top: 0;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 1.4;
        font-weight: 600;
    }
    ul {
        margin-left:30px;
    }
    .trusted-container {
        padding-top:80px;
        padding-bottom: 50px;
    }
    .testimonial-subtitle {
        margin-top: 20px;
    }
    .socialproof-section {
        padding: 0 1.5rem 8rem 1.5rem;
    }
    .bottom-spacer-20 {
        padding-bottom: 20px;
    }
    .right-spacer-40 {
        margin-right: 40px;
    }
    .top-spacer-40 {
        margin-top: 40px;
    }
    .left-button {
        padding-top: 30px;
        padding-bottom: 30px;
        max-width: 550px;
        width: 100%;
        display: flex;
        font-weight: bold;
        font-size: 18px;
        justify-content: space-between;
    }
    .center {
        text-align: center
    }
    .integration-item > .padding {
        padding: 20px;
        max-height: 100px;
    }
    @media (max-width: 1000px) {
        .trusted-container {
            padding-top:60px;
        }
    }
    @media (max-width: 800px) {
        .trusted-container {
            padding-top:40px;
        }
    }
    @media (max-width: 600px) {
        .trusted-container {
            padding-top:20px;
            padding-bottom: 40px;
        }
    }
    @media (max-width: 991px) {
        .small-top-header {
            display: block;
            font-size: 56px;
            font-weight: bold;
            color: #000;
            text-align: center;
            margin-bottom: 50px;
        }
        .top-header {
            display: none;
        }
    }
    @media (max-width: 479px) {
        .integration-item {
            padding-left: 4px;
            padding-right: 4px;
        }
        .integration-item > .padding {
            padding: 4px;
            height: 50px;
            object-fit: contain;
        }
        .small-top-header {
            font-size: 36px;
            margin-top: 50px;
            margin-bottom: 0;
        }
        .left-button {
            justify-content: center;
        }
        .columns-2 {
            display: block;
        }
        .column {
            padding: 0 10px 0 0;
        }
        .socialproof-section {
            padding: 2rem 1.5rem 4rem 1.5rem;
        }
        ._123:not(:last-child) {
            margin-bottom: 40px;
        }
        .w-col-4 {
            width: 100%;
        }
        .w-col-8 {
            width: 100%;
        }
        .award {
            padding: 0;
            max-height: 50px;
            margin: 10px 20px;
        }
        ul {
            margin-left:0;
        }
        li {
            margin-left:0;
        }
    }
</style>

<script>
    import HeaderMenu from "../components/HeaderMenu";
    import NetworkStatus from "../components/NetworkStatus.vue";
    import Plans from "../components/Plans";
    import Footer from "../components/Footer";

    const data = {
        localCities: '19k',
        zipCodes: '41k',
        adsServedToDate: '250B'
    };

    export default {
        data () {
            return data;
        },
        components: {
            HeaderMenu, NetworkStatus, Plans, Footer
        }
    }
</script>
